import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TableSettingsService } from '../../table-utils/table-settings.service';

@Component({
  selector: 'hf-search-box',
  templateUrl: './search-box.component.html',
  styleUrls: ['./search-box.component.scss']
})
export class SearchBoxComponent implements OnInit, OnDestroy {
  @Input() public placeholder = '';
  @Input() public fieldName: string;
  @Input() public icon = 'search';

  public group = new UntypedFormGroup({ searchBox: new UntypedFormControl() });

  private unsubscribe$ = new Subject();

  constructor(private tableSettingsService: TableSettingsService) {}

  ngOnInit() {
    this.group.get('searchBox').setValue(this.tableSettingsService.tableParams.filter);

    this.group
      .get('searchBox')
      .valueChanges.pipe(takeUntil(this.unsubscribe$))
      .subscribe((filter) => this.tableSettingsService.filterRequest(filter));
  }

  ngOnDestroy() {
    this.unsubscribe$.next('');
    this.unsubscribe$.complete();
  }

  public clear() {
    this.group.get('searchBox').setValue('');
  }

  public get hasValue(): boolean {
    return !!this.group.get('searchBox').value;
  }
}
